import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';

function* getTrades({ payload }) {
  try {
    const { data, status } = yield call(api.trades.getTrades, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_TRADES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_TRADES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* trades() {
  yield all([takeLatest(types.GET_TRADES_START, getTrades)]);
}
